import React, { useContext, useEffect, useState } from "react";

import {
  batchNumberReport,
  ReportDaily,
  ReportDateRange,
} from "../../api/FetchAPI";
import { GenRequest, THeader } from "../../lib/interfaces/ReportsInterface";
import { showAlert, stopLoading } from "../../promptMessages/PromptMessages";
import { AuthContext } from "../../components/AuthContextComponent";
import { getPartners } from "../../api/FetchAPI";
import {
  formatReportApprovalDate,
  getCurrentDate,
  getCurrentLastDateOfTheMonth,
  lower1stLetter,
} from "../../lib/formatter/Formatter";
import moment from "moment";
import { ALERTMSG } from "../../lib/enums/AlertMsgs";
import { ALERTICON } from "../../lib/enums/AlertIcon";
import { STATUS, TYPE } from "../../lib/enums/Type";
import useReport from "../../hooks/Reporthook";
import { TbReportAnalytics } from "react-icons/tb";
import { FaCalendarDay } from "react-icons/fa6";
import { IoCalendarSharp } from "react-icons/io5";
import { BsFillFileBinaryFill } from "react-icons/bs";
import ReportCustomDropdown from "../../components/dropdown/ReportDropdown";
import PartnersListDropdown from "../../components/dropdown/PartnersListDropdown";
import useManualUpload from "../../hooks/ManualUploadhook";
import ReportStatusCustomDropdown from "../../components/dropdown/ReportsStatusDropdown";
import LoadingComponent from "../../components/loading/Loading";
import { statusOptions } from "../../lib/constants/Constants";
import { useUserLogin } from "../../hooks";
import { FetchErr } from "../../lib/helpers/UnhandledError";

const ReportsPage: React.FC<any> = (props: any) => {
  const {
    setHeaders,
    setLists,
    setTotalPHP,
    setTotalPrincipalPHP,
    setTotalFeePHP,
    setTotalUSD,
    setTotalPrincipalUSD,
    setTotalFeeUSD,
    setPdfDate,
    setPdfDateRangeFrom,
    setPdfDateRangeTo,
    setPdfBatchNumber,
    setIsOpen,
    setIsGenerating,
    setCurrentPage,
    setSelectedPartner,
    selectedpartner,
    setPartners,
    partners,
  } = props;
  const { dates, setDate } = useReport();
  const { customColor } = useUserLogin();
  const { requiredPartner, setRequiredPartner } = useManualUpload();
  const userInfo = useContext(AuthContext);
  const { username, setPartnerName } = useContext(AuthContext);
  const requestPayload: any = {
    userId: username,
  };
  const [todate, setToDate] = useState(getCurrentLastDateOfTheMonth());
  const [fromdate, setFromDate] = useState(getCurrentDate());
  const [batchNumber, setBatchNumber] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("AVAILABLE");
  const [selectedReportType, setSelectedReportType] = useState("daily");
  const [dateError, setDateError] = useState("");
  const [isDateError, setIsDateError] = useState(false);
  const [batchNumberError, setBatchNumberError] = useState("");
  const [loading, setLoading] = useState(true);
  const themeBackground = userInfo.userInfo?.theme === "DARK" ? "#24292e" : "";
  const themeTextColor = userInfo.userInfo?.theme === "DARK" ? "#fafbfc" : "";

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDate(event.target.value);
  };

  const handleFromDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFromDate(event.target.value);
  };

  const handleToDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setToDate(event.target.value);

    if (isDateError) {
      setIsDateError(false);
    }
  };

  const handleBatchNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setBatchNumber(event.target.value);
    if (batchNumberError) {
      setBatchNumberError("");
    }
  };

  const handleStatusChange = (value: string) => {
    setSelectedStatus(value);
  };

  const handleReportTypeChange = (value: string) => {
    if (value === TYPE.DAILY) {
      setFromDate("");
      setToDate("");
      setBatchNumber("");
      setBatchNumberError("");
      setIsOpen(false);
      setDate(getCurrentDate());
      setSelectedReportType(value);
    } else if (value === TYPE.DATERANGE) {
      setDate("");
      setIsOpen(false);
      setBatchNumber("");
      setBatchNumberError("");
      setFromDate(getCurrentDate());
      setToDate(getCurrentLastDateOfTheMonth());
      setSelectedReportType(value);
    } else if (value === "batchnumber") {
      setDate("");
      setFromDate("");
      setToDate("");
      setIsOpen(false);
      setSelectedReportType(value);
    }
  };

  const generateReportData = async () => {
    if (userInfo.userInfo?.category === STATUS.INTERNAL && !selectedpartner) {
      return setRequiredPartner(true);
    }

    // generateLoading(ALERTMSG.LOADING, themeBackground, themeTextColor);
    setIsGenerating(true);
    setIsOpen(false);
    const userId = username;
    let partnersId = "";

    if (userInfo?.userInfo?.category === STATUS.INTERNAL) {
      partnersId = selectedpartner?.toString() || "";
    } else {
      partnersId = userInfo?.userInfo?.partnersId.toString() || "";
    }

    const date = dates.toString();
    const from = fromdate.toString();
    const to = todate.toString();
    const status = selectedStatus;

    setPdfDate(date);
    setPdfDateRangeFrom(from);
    setPdfDateRangeTo(to);
    setPdfBatchNumber(batchNumber);

    // Handle date-specific report generation
    if (date) {
      const response = await ReportDaily(userId, partnersId, date, status);
      handleReportResponse(response);
    } else if (from && to) {
      const response = await ReportDateRange(
        userId,
        partnersId,
        from,
        to,
        status
      );
      handleReportResponse(response);
    } else {
      // Generate report by batch number
      if (!batchNumber) {
        setBatchNumberError("*Required");
        stopLoading(); // Call this after setting the error
        setIsGenerating(false);
        return; // Exit the function early
      } else {
        const response = await batchNumberReport(
          userId,
          batchNumber,
          partnersId,
          status
        );
        handleReportResponse(response);
      }
    }
  };

  const handleReportResponse = (response: any) => {
    const header = response?.header ? response.header[0] : null;
    const list = response?.list;
    const totalPHP = response?.totalPHP;
    const totalPrincipalPHP = response?.totalPrincipalPHP;
    const totalFeePHP = response?.totalFeePHP;
    const totalUSD = response?.totalUSD;
    const totalPrincipalUSD = response?.totalPrincipalUSD;
    const totalFeeUSD = response?.totalFeeUSD;

    setTotalPHP(totalPHP);
    setTotalPrincipalPHP(totalPrincipalPHP);
    setTotalFeePHP(totalFeePHP);
    setTotalUSD(totalUSD);
    setTotalPrincipalUSD(totalPrincipalUSD);
    setTotalFeeUSD(totalFeeUSD);
    setIsOpen(true);
    setIsGenerating(false);
    const rspMsg = response?.respMsg || "";
    const rspCode = response?.respCode;

    if (header && list) {
      stopLoading();
      setIsGenerating(false);
      setCurrentPage(1);
      const cleanheader = GenerateHeader(header);
      const cleanlist = GetList(list, cleanheader);
      handleHeader(cleanheader);
      handleLists(cleanlist);
    } else {
      setIsOpen(false);
      setIsGenerating(false);
      stopLoading();
      showAlert(
        ALERTMSG.ERR,
        `${rspMsg} (${rspCode})`,
        ALERTICON.ERR,
        customColor,
        themeBackground,
        themeTextColor
      );
    }
  };

  const handleHeader = (header: any) => {
    setHeaders(header);
  };

  const handleLists = (lists: any) => {
    setLists(lists);
  };

  const GetList = (list: GenRequest[], cleanHeader: THeader[]) => {
    return list
      .map((item) => {
        const entries = cleanHeader.map((header) => {
          if (header.id === "ApprovedDate") {
            return [
              header.id,
              formatReportApprovalDate(item.approvedDate, item.status),
            ];
          }

          if (header.id === "TransDate") {
            return [
              header.id,
              moment(item[lower1stLetter(header.id)]).format(
                "MMM DD,YYYY hh:mm A"
              ),
            ];
          }

          return [header.id, item[lower1stLetter(header.id)]];
        });

        return Object.fromEntries(entries);
      })
      .sort((a, b) => {
        return a.TransDate.localeCompare(b.TransDate);
      });
  };

  const GenerateHeader = (header: GenRequest) => {
    const headerKeys = Object.keys(header);
    return headerKeys
      .filter((item) => header[item] === true)
      .map((item) => item.substring(4))
      .sort((a, b) => header[`line${a}`] - header[`line${b}`])
      .reduce((acc: THeader[], curr) => {
        acc.push({
          id: curr,
          label: header[`label${curr}`],
          minWidth: 170,
        });

        return acc;
      }, []);
  };

  const fetchPartners = async () => {
    try {
      const partners1 = await getPartners(requestPayload);
      setPartners(partners1);
    } catch (error: any) {
      FetchErr(error, themeBackground, customColor, themeTextColor);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        if (userInfo.userInfo?.category !== STATUS.INTERNAL) {
          setLoading(false);

          return;
        } else {
          setPartnerName("");

          await fetchPartners();
        }
      } catch (error) {
        // Optional: Handle error
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [username, userInfo.userInfo?.category]);

  const PartnersChange = (value: number) => {
    setSelectedPartner(value);
    findPartnerNameById(value);

    if (requiredPartner) {
      setRequiredPartner(false);
    }
  };

  const findPartnerNameById = (id: number) => {
    const partner = partners?.find((p: any) => p.id === id);
    // setSelectedPartnerName(partner?.name || "");
    setPartnerName(partner?.name || "");
  };

  const options = [
    {
      label: (
        <>
          <FaCalendarDay /> DAILY
        </>
      ),
      value: "daily",
    },
    {
      label: (
        <>
          <IoCalendarSharp /> DATE RANGE
        </>
      ),
      value: "daterange",
    },
    {
      label: (
        <>
          <BsFillFileBinaryFill /> BATCH NUMBER
        </>
      ),
      value: "batchnumber",
    },
  ];

  return (
    <div>
      <div>
        {loading ? (
          <>
            <div className="flex justify-center max-w-[1240px] mx-auto px-4 h-full items-center p-96">
              <LoadingComponent customColor={customColor} />
            </div>
          </>
        ) : (
          <>
            <div className="flex flex-col flex-wrap items-start justify-center gap-2 py-3 mx-auto md:px-10 md:justify-start">
              <div className="flex flex-row flex-wrap justify-center w-full py-1 md:justify-start">
                <div className="flex flex-col items-start">
                  <p
                    className={`pl-4 text-custom-micro pb-1 ${
                      userInfo.userInfo?.theme === `DARK`
                        ? `text-custom-dark-theme-text`
                        : ``
                    }`}
                  >
                    Report Type
                  </p>

                  <ReportCustomDropdown
                    options={options}
                    onSelect={handleReportTypeChange}
                  ></ReportCustomDropdown>
                </div>
                {selectedReportType === "daily" ? (
                  <div className="flex flex-col items-start py-1 text-custom-micro md:py-0">
                    <label
                      className={`ml-1 pl-3 pb-1 ${
                        userInfo.userInfo?.theme === `DARK`
                          ? `text-custom-dark-theme-text`
                          : ``
                      }`}
                    >
                      Date
                    </label>

                    <input
                      type="date"
                      onChange={handleDateChange}
                      value={dates}
                      className="rounded-md p-2 h-[30px] ml-2 w-[311px] border border-gray-300 hover:bg-slate-100 text-custom-petite"
                    ></input>
                  </div>
                ) : selectedReportType === "daterange" ? (
                  <div className="flex flex-wrap items-center justify-center w-full gap-2 pt-2 text-custom-micro md:justify-start">
                    <div className="flex flex-col">
                      <label
                        className={`ml-1 pl-3 pb-1 ${
                          userInfo.userInfo?.theme === `DARK`
                            ? `text-custom-dark-theme-text`
                            : ``
                        }`}
                      >
                        Date From
                      </label>
                      <input
                        type="date"
                        onChange={handleFromDateChange}
                        value={fromdate}
                        className="rounded-md p-2 h-[30px] ml-2 w-[311px] border border-gray-300 hover:bg-slate-100 text-custom-petite"
                      ></input>
                    </div>

                    <div className="flex flex-col p-1 text-custom-micro">
                      <label
                        className={`ml-1 pl-3 pb-1 ${
                          isDateError ? `mt-6 ` : ``
                        } ${
                          userInfo.userInfo?.theme === `DARK`
                            ? `text-custom-dark-theme-text`
                            : ``
                        }`}
                      >
                        Date To
                      </label>
                      <input
                        type="date"
                        onChange={handleToDateChange}
                        value={todate}
                        className={`rounded-md p-2 h-[30px]  w-[311px] border border-gray-300 hover:bg-slate-100 text-custom-petite`}
                      ></input>
                      {isDateError ? (
                        <span className={`text-custom-default pl-3`}>
                          {dateError}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                ) : selectedReportType === "batchnumber" ? (
                  <div className={`flex flex-col text-custom-micro `}>
                    <label
                      className={`ml-1 pl-3 pb-1 ${
                        userInfo.userInfo?.theme === `DARK`
                          ? `text-custom-dark-theme-text`
                          : ``
                      }`}
                    >
                      Batch Number
                    </label>

                    <input
                      required
                      type="text"
                      value={batchNumber}
                      onChange={handleBatchNumberChange}
                      className={`rounded-md p-2 h-[30px] ml-2 w-[311px] border border-gray-300 hover:bg-slate-100 text-custom-petite ${
                        batchNumberError ? `border-red-600` : ``
                      }`}
                    ></input>
                    {batchNumberError ? (
                      <span className="pl-4 text-custom-default">
                        {batchNumberError}
                      </span>
                    ) : (
                      <></>
                    )}
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <div className="flex flex-row flex-wrap justify-center w-full md:justify-start">
                {" "}
                {userInfo.userInfo?.category === STATUS.INTERNAL ? (
                  <div className={`flex items-start flex-col `}>
                    <PartnersListDropdown
                      label="Partner"
                      options={partners || []}
                      isRequired={requiredPartner}
                      onSelect={PartnersChange as any}
                    ></PartnersListDropdown>
                  </div>
                ) : null}
                {selectedReportType !== "batchnumber" && (
                  <div className="flex flex-col items-start py-1 md:py-0">
                    <p
                      className={`pl-4 text-custom-micro pb-1 ${
                        userInfo.userInfo?.theme === `DARK`
                          ? `text-custom-dark-theme-text`
                          : ``
                      }`}
                    >
                      Status
                    </p>

                    <ReportStatusCustomDropdown
                      options={statusOptions}
                      onSelect={handleStatusChange}
                    ></ReportStatusCustomDropdown>
                  </div>
                )}
                <div className="flex py-[23px] px-4 items-center justify-center md:justify-start">
                  <button
                    onClick={generateReportData}
                    style={{
                      backgroundColor: customColor,
                    }}
                    className={`flex items-center gap-2 px-4 py-2 w-[180px] h-[30px] text-custom-micro bg-custom-default text-white rounded-md ${
                      selectedReportType ? "" : "opacity-60 cursor-not-allowed"
                    } ${
                      customColor
                        ? `hover:scale-105 transition-all duration-300`
                        : `hover:bg-custom-default-hover hover:shadow-lg hover:shadow-red-500/40`
                    }`}
                    disabled={!selectedReportType}
                  >
                    <TbReportAnalytics className="text-lg" /> Generate Report
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ReportsPage;
